import React, { useEffect, useState } from 'react';
import { Box, Card, IconButton, Typography } from '@mui/material';
import { DeleteOutline, InsertDriveFileOutlined } from '@mui/icons-material';

const FilePreviewCard = ({ file, onDelete, deleteLabel }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const isImage = file.type?.startsWith('image/');

  useEffect(() => {
    if (!isImage) return undefined;

    const objectUrl = URL.createObjectURL(file);
    setPreviewUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file, isImage]);

  return (
    <Card variant="outlined" sx={{ position: 'relative', minWidth: 0 }}>
      <Box
        sx={{
          height: 110,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'grey.100',
          overflow: 'hidden',
        }}>
        {previewUrl ? (
          <Box component="img" src={previewUrl} alt={file.name} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <InsertDriveFileOutlined color="action" sx={{ fontSize: 48 }} />
        )}
      </Box>
      <IconButton
        size="small"
        onClick={onDelete}
        aria-label={deleteLabel}
        sx={{ position: 'absolute', top: 6, right: 6, bgcolor: 'background.paper', '&:hover': { bgcolor: 'grey.200' } }}>
        <DeleteOutline fontSize="small" />
      </IconButton>
      <Box sx={{ p: 1.5 }}>
        <Typography variant="body2" noWrap title={file.name}>
          {file.name}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {(file.size / 1024 / 1024).toFixed(1)} MB
        </Typography>
      </Box>
    </Card>
  );
};

export default FilePreviewCard;
